const normalizeDigits = value => (value || "").replace(/\D/g, "");

export const formatContactDisplayName = contact => {
  const rawName = (contact?.name || "").trim();
  const rawNumber = (contact?.number || "").trim();

  if (!rawName) {
    return rawNumber;
  }

  if (!rawNumber) {
    return rawName;
  }

  const normalizedNameDigits = normalizeDigits(rawName);
  const normalizedNumberDigits = normalizeDigits(rawNumber);

  if (
    normalizedNameDigits &&
    normalizedNumberDigits &&
    normalizedNameDigits === normalizedNumberDigits
  ) {
    return rawName;
  }

  return `${rawName} - ${rawNumber}`;
};

export const getContactAvatarFallback = contact => {
  const rawName = (contact?.name || "").trim();
  const rawNumber = (contact?.number || "").trim();
  const source = rawName || rawNumber;

  if (!source) {
    return "?";
  }

  return source.charAt(0).toUpperCase();
};
